var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9 10C0.9 15.018 4.98197 19.1 10 19.1C15.018 19.1 19.1 15.018 19.1 10C19.1 4.98197 15.018 0.9 10 0.9C4.98197 0.9 0.9 4.98197 0.9 10ZM2.225 10C2.225 5.71275 5.71275 2.225 10 2.225C14.2873 2.225 17.775 5.71275 17.775 10C17.775 14.2873 14.2873 17.775 10 17.775C5.71275 17.775 2.225 14.2873 2.225 10Z",
    fill: "#EF4444",
    stroke: "#EF4444",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0625 10.6625H13.9375C14.3032 10.6625 14.6 10.3657 14.6 10C14.6 9.63427 14.3032 9.3375 13.9375 9.3375H6.0625C5.69677 9.3375 5.4 9.63427 5.4 10C5.4 10.3657 5.69677 10.6625 6.0625 10.6625Z",
    fill: "#EF4444",
    stroke: "#EF4444",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusRed);
export default __webpack_public_path__ + "static/media/MinusRed.c1a933854a95203e19f9b882682650bc.svg";
export { ForwardRef as ReactComponent };